import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TopPerformersPanel = ({ performers }) => {
  return (
    <div className="card p-6 md:p-7 lg:p-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-success/10 rounded-xl flex items-center justify-center">
            <Icon name="Trophy" size={24} color="var(--color-success)" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-foreground">
              Top Performers
            </h3>
            <p className="text-sm text-muted-foreground">
              Mejores referidores del mes
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        {performers?.map((performer, index) => (
          <div
            key={performer?.id}
            className="flex items-center space-x-4 p-4 rounded-xl bg-muted/50 hover:bg-muted transition-smooth"
          >
            {/* Rank Badge */}
            <div className={`
              w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg
              ${index === 0 ? 'bg-warning text-warning-foreground' : 
                index === 1 ? 'bg-muted text-foreground': 'bg-accent/20 text-accent'}
            `}>
              {index + 1}
            </div>

            {/* Profile */}
            <Image
              src={performer?.avatar}
              alt={performer?.avatarAlt}
              className="w-12 h-12 rounded-full object-cover"
            />

            {/* Info */}
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-foreground text-sm md:text-base truncate">
                {performer?.name}
              </h4>
              <p className="text-xs text-muted-foreground">
                {performer?.totalReferrals} referidos • {performer?.monthlySales} ventas
              </p>
            </div>

            {/* Commission */}
            <div className="text-right">
              <p className="text-lg font-bold text-success">
                S/ {performer?.monthlyCommission?.toLocaleString('es-PE', { minimumFractionDigits: 2 })}
              </p>
              <p className="text-xs text-muted-foreground">
                Nivel {performer?.level}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopPerformersPanel;